import {
  Crown,
  Clock4,
  Eye,
  User,
  ZodiacAquarius,
  ZodiacAries,
  ZodiacCancer,
  ZodiacCapricorn,
  ZodiacGemini,
  ZodiacLeo,
  ZodiacLibra,
  ZodiacOphiuchus,
  ZodiacPisces,
  ZodiacSagittarius,
  ZodiacScorpio,
  ZodiacTaurus,
  ZodiacVirgo,
} from 'lucide-react';

const ZODIAC_ICONS = {
  'zodiac-aquarius': ZodiacAquarius,
  'zodiac-aries': ZodiacAries,
  'zodiac-cancer': ZodiacCancer,
  'zodiac-capricorn': ZodiacCapricorn,
  'zodiac-gemini': ZodiacGemini,
  'zodiac-leo': ZodiacLeo,
  'zodiac-libra': ZodiacLibra,
  'zodiac-ophiuchus': ZodiacOphiuchus,
  'zodiac-pisces': ZodiacPisces,
  'zodiac-sagittarius': ZodiacSagittarius,
  'zodiac-scorpio': ZodiacScorpio,
  'zodiac-taurus': ZodiacTaurus,
  'zodiac-virgo': ZodiacVirgo,
};

/** Lucide strokes follow CSS `color` on the wrapper (ikonin väri). */
export function BadgeGlyph({ badgeType, iconColor, size = 18 }) {
  const color = `#${iconColor}`;
  if (badgeType === 'pallo') {
    return (
      <span
        className="AvatarDesigner-badge-pallo"
        style={{ backgroundColor: color, width: size, height: size }}
        aria-hidden
      />
    );
  }
  if (badgeType === 'p') {
    return (
      <span
        className="AvatarDesigner-badge-letter"
        style={{ color, fontSize: Math.max(8, size * 0.65) }}
        aria-hidden
      >
        P
      </span>
    );
  }
  const wrapStyle = { color, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 0 };
  const iconProps = {
    size,
    strokeWidth: 2.25,
    stroke: 'currentColor',
    fill: 'none',
    'aria-hidden': true,
  };
  if (badgeType === 'crown') {
    return (
      <span style={wrapStyle}>
        <Crown {...iconProps} />
      </span>
    );
  }
  if (badgeType === 'clock4') {
    return (
      <span style={wrapStyle}>
        <Clock4 {...iconProps} />
      </span>
    );
  }
  if (badgeType === 'eye') {
    return (
      <span style={wrapStyle}>
        <Eye {...iconProps} />
      </span>
    );
  }
  if (badgeType === 'user') {
    return (
      <span style={wrapStyle}>
        <User {...iconProps} />
      </span>
    );
  }
  const ZIcon = ZODIAC_ICONS[badgeType];
  if (ZIcon) {
    return (
      <span style={wrapStyle}>
        <ZIcon {...iconProps} />
      </span>
    );
  }
  return null;
}
